import { useTranslation } from 'react-i18next'

import { EMPTY_LIST, EMPTY_OBJECT } from '../../../../../../../constants/common'
import {
  ButtonSelectControl,
  SelectContextProvider,
  SelectValueTags,
} from '../../../../../../Select'
import { useChangeFields } from '../CustomizeRecipientAudienceField.hooks'
import { parseTagValues } from '../CustomizeRecipientAudienceField.utils'

import { QA_NAME_RECIPIENTS_SELECT } from './RecipientsSelect.constants'
import {
  checkIsNeedToShowClearButton,
  getTagText,
  getValue,
} from './RecipientsSelect.utils'

import * as styles from '../CustomizeRecipientAudienceField.module.css'

function RecipientsSelect({
  controlProps = EMPTY_OBJECT,
  disabled,
  error,
  initialValues,
  isSubmitted,
  setInitialValues,
  onChangeRecipientField,
  onClick,
}) {
  const { t } = useTranslation()

  const selectedTags = isSubmitted ? parseTagValues(initialValues) : EMPTY_LIST

  const { handleChangeTagList } = useChangeFields({
    getTagValue: getValue,
    initialValues,
    setInitialValues,
    onChangeRecipientField,
  })

  function handleTagClick(item) {
    const nextList = selectedTags.filter(
      tag => getValue(tag) !== getValue(item)
    )

    handleChangeTagList(nextList, item)
  }

  function handleClearTags() {
    handleChangeTagList([], null)
  }

  function handleClick() {
    if (!disabled) {
      onClick?.()
    }
  }

  const selectContextValue = {
    disabled,
    error,
    handleToggleOpen: handleClick,
    isOpen: false,
    qaName: QA_NAME_RECIPIENTS_SELECT,
    value: selectedTags,
  }

  return (
    <div className={styles.selectButton}>
      <SelectContextProvider {...selectContextValue}>
        <ButtonSelectControl
          {...controlProps}
          contentProps={{
            ValueItem: null,
            placeholderProps: {
              className: styles.placeholder,
              text: t('Newsboard.AddRecipientsPlaceholderKey'),
            },
          }}
          indicatorsProps={{
            checkIsNeedToShowClearButton,
          }}
          openDropdownOnClickContainer={false}
          onClickContainer={handleClick}
        />
        <SelectValueTags
          disabled={disabled}
          getText={getTagText}
          value={selectedTags}
          onChange={handleTagClick}
          onClear={handleClearTags}
        />
      </SelectContextProvider>
    </div>
  )
}

export default RecipientsSelect
